import { render, staticRenderFns } from "./UserLimit.vue?vue&type=template&id=287a9a00&"
import script from "./UserLimit.vue?vue&type=script&lang=js&"
export * from "./UserLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports